import commonActions from '@/store/data/common/actions'
import { get, includes, isEqual, isNil, isNull, size } from 'lodash'

const actions = {
    ...commonActions,
    selectNodes({ commit, state }, params) {
        if (params.action === 'add' && isNil(get(state.selectedClusters, params.taxoId, null))) {
            commit('setSelectedTaxo', { taxoId: params.taxoId })
        }
        if (!isNil(params.nodeId)) {
            //add/remove one node:
            // first check if all nodes are about to be selected on add action OR if all nodes are selected on remove action
            // then add/remove selected node
            if (
                (params.action === 'add' && isEqual(params.clusterSize, size(state.selectedClusters[params.taxoId]) + 1)) ||
                (params.action === 'remove' && includes(state.selectAllTaxoIds, params.taxoId))
            ) {
                commit('setSelectedAllTaxoIds', { taxoId: params.taxoId, action: params.action })
            }
            commit('setSelectedCluster', params)
        } else if (!isNull(params.nodesIds)) {
            //add/remove a list of nodes
            commit('setSelectedClusters', params)
        }
    }
}

export default actions
